import React from 'react';

export default {
  fields: [
    {
      type: 'text',
      name: 'title',
      props: {
        label: <p><i className='asterisk icon inline' />Prize Title</p>,
        required: true,
        helpContent: '',
        helpHeader: ''
      }
    },
    {
      type: 'radio',
      name: 'lang',
      props: {
        label: <p><i className='asterisk icon inline' />Which site?</p>,
        required: true,
        options: [
          {key: 'en-US', text: 'Dailybreak', value: 'en-US'},
          {key: 'es-LA', text: 'El Dailybreak', value: 'es-LA'},
          {key: 'en-GB', text: 'Dailybreak UK', value: 'en-GB'}
        ]
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/components/prizes/copyPrizeFormConfig.jsx